<template>
  <div class="half-transfer">
    <div class="messageTransfer">
      <div class="iconTransfer">
        <md-icon
          class="icon"
          md-src="/static/images/icon-transfer-sucess.svg"
        />
      </div>
      <div class="flex-5">
        <p>
          <span class="highlight highlight-green">{{ transferReports.samplesCount }}</span>
          <span v-if="transferReports.samplesCount > 1">Amostras geradas com <br>sucesso!</span>
          <span v-else>Amostra gerada com <br>sucesso!</span>
        </p>
      </div>
    </div>
    <div class="messageTransfer">
      <div class="iconTransfer">
        <md-icon
          class="icon"
          md-src="/static/images/icon-transfer-fail.svg"
        />
      </div>
      <div class="flex-5">
        <p>
          Falha na transferência de
          <span
            class="highlight highlight-red"
          >
            {{ transferReports.failTransmitOrdersCount }}
          </span>
          <br>
          <span v-if="transferReports.failTransmitOrdersCount > 1">ordens de serviço!</span>
          <span v-else>ordem de serviço</span>
        </p>
      </div>
    </div>
    <div>
      <button
        class="btn btn-primary button"
        @click="pushToFailedOrders()"
      >
        VISUALIZAR FALHAS
      </button>
      <br>
      <button
        class="btn btn-nonenary button"
        @click="pushToPrint()"
      >
        VISUALIZAR AMOSTRAS E LOTES
      </button>
      <br>
      <button
        class="btn btn-primary button"
        @click="redirectToDocRequiredPage()"
      >
        ANEXAR DOCUMENTOS OBRIGATÓRIOS
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'HalfTransfer',
  props: {
    transferReports: Object,
    pushToPrint: Function,
    pushToFailedOrders: Function
  },
  computed: {
    ...mapGetters(['preference'])
  },
  methods: {
    redirectToDocRequiredPage() {
      this.$router.replace('/documentos-obrigatorios')
    }
  }
}
</script>

<style lang="scss">
.half-transfer {
  .md-icon {
    height: 41px;
    width: 41px;
  }

  .md-dialog-content {
    padding: 0 20px 34px;
  }

  .messageTransfer {
    display: flex;
    flex-direction: row;
  }
  .iconTransfer {
    flex: 1;
    padding-bottom: 10px;
  }
  p {
    padding: 1px 0 23px;
    text-align: start;
    font-family: Roboto, sans-serif;
    font-style: normal;
    color: #617173;
    line-height: 19px;
    font-size: 15px;
    font-weight: 400;
    margin-left: 10px;
  }
  .button {
    width: 100%;
    margin-top: 10px;
    font-family: Roboto, sans-serif;
    border-radius: 3px;
    font-weight: 500;
    letter-spacing: 0.4px;
  }

  .highlight {
    font-weight: 900;

    &-red {
      color: #b40607;
    }

    &-green {
      color: #219653;
    }
  }

  .flex-5 {
    flex: 5;
  }
}
</style>
